import {Address} from './address';
export class GlobalData {
  public static ageToAgeService: any;
  public static router: any;

}
